
export class MobileAppUpdateInformationDto {
  isForceUpdate?: boolean;
  isUpdateAvailable?: boolean;
  version?: string;
  url?: string;
  message?: string;
}
